import { PoliticalExposureInformation } from "../../model/PoliticalExposureType";

export const validateField = (
  field: string,
  value: string | null,
  setFieldError: (field: string, message: (string | undefined)) => void,
): boolean => {
    let error: string | undefined = undefined;

    if (field === "izvorSredstava") {
        const stringValue = typeof value === 'string' ? value : '';
        if (!stringValue.trim()) {
            error = "common.validation-error.required";
        }
    } else if (field === "izvorSredstavaBanka") {
        const stringValue = typeof value === 'string' ? value : '';
        if (!stringValue.trim()) {
          error = "common.validation-error.required";
        }
    } else if (field.includes("imePrezime")) {
        const stringValue = typeof value === 'string' ? value : '';
        const lastNameRegex = /^[a-zA-ZčćžđšČĆŽĐŠ\- ]+$/;

        if (!stringValue.trim()) {
          error = "common.validation-error.required";
        } else if (!lastNameRegex.test(stringValue)) {
            error = "common.validation-error.type.letter-space-line";
        }
    } else if (field.includes("funkcija")) {
        const stringValue = typeof value === 'string' ? value : '';
        const lastNameRegex = /^[a-zA-ZčćžđšČĆŽĐŠ\- ]+$/;

        if (!stringValue.trim()) {
          error = "common.validation-error.required";
        } else if (!lastNameRegex.test(stringValue)) {
            error = "common.validation-error.type.letter-space-line";
        }
    }

    setFieldError(field, error);

    return error === undefined;
};

export const validateForm = (values: PoliticalExposureInformation, setFieldError: (field: string, message: (string | undefined)) => void): boolean => {
    let isFormValid = true;
    const hasIzvorSredstava = values.celnikDrzava || values.clanZakonodavnogTijela || values.clanUpravnogTijelaPolitika || values.sudVrhovniUstavni || values.sudRevizorski
      || values.sudRevizorski || values.clanSavjetaSredisnjeBanke || values.diplomat || values.clanNadzornogOdbora || values.clanMedjunarodnaOrganizacija || values.celnikLokalnaVlast
      || values.clanBracni || values.clanPotomak || values.clanRoditelj || values.suradnikPoslovniZajedno || values.suradnikPoslovni;
    const hasPolitickeOsobe = values.clanBracni || values.clanPotomak || values.clanRoditelj
      || values.suradnikPoslovniZajedno || values.suradnikPoslovni;

    if (hasIzvorSredstava) {
        if (!validateField("izvorSredstava", values.izvorSredstava, setFieldError) || !validateField("izvorSredstavaBanka", values.izvorSredstavaBanka, setFieldError)) {
            isFormValid = false;
        }
    }

    if (hasPolitickeOsobe) {
        const politickeOsobe = values.politickeOsobe ?? [];

        if (politickeOsobe.length === 0) {
            isFormValid = false;
        }

        for (let i = 0; i < politickeOsobe.length; i++) {
            if (!validateField(`politickeOsobe[${i}].imePrezime`, politickeOsobe[i].imePrezime, setFieldError)
              || !validateField(`politickeOsobe[${i}].funkcija`, politickeOsobe[i].funkcija, setFieldError)) {
                isFormValid = false;
            }
        }
    }

    return isFormValid;
}
